import Vue from 'vue'
// @ts-ignore
import HtmlParser from '~/components/_core/HtmlParser.vue'

Vue.component('HtmlParser', HtmlParser)
